(() => {
  if (window.__qlsMobileCartDrawerSummaryInstalled) return;
  window.__qlsMobileCartDrawerSummaryInstalled = true;

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  let initializedPanel = null;

  const getDrawer = () => document.getElementById('cart-drawer');

  function getParts() {
    const drawer = getDrawer();
    if (!drawer) return {};

    return {
      drawer,
      scroller: drawer.querySelector('.drawer__content'),
      summary: drawer.querySelector('.cart-drawer__summary'),
      toggle: drawer.querySelector('[data-qls-mobile-cart-summary-toggle]'),
      panel: drawer.querySelector('[data-qls-mobile-cart-summary-panel]')
    };
  }

  function setExpanded(expanded, focusToggle = false) {
    const { summary, toggle, panel } = getParts();
    if (!summary || !toggle || !panel) return;

    const shouldExpand = mobileQuery.matches && expanded;
    summary.classList.toggle('qls-mobile-summary-open', shouldExpand);
    toggle.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
    panel.setAttribute('aria-hidden', shouldExpand ? 'false' : 'true');

    if (focusToggle) toggle.focus({ preventScroll: true });
  }

  function initializeCurrentPanel() {
    const { panel } = getParts();
    if (!panel || panel === initializedPanel) return;

    initializedPanel = panel;
    setExpanded(false);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-qls-mobile-cart-summary-toggle]');
    if (toggle) {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    }
  });

  document.addEventListener('scroll', (event) => {
    const { scroller } = getParts();
    if (!scroller || event.target !== scroller) return;

    if (scroller.scrollTop > 12) setExpanded(false);
  }, true);

  document.addEventListener('dispatch:cart-drawer:open', () => {
    initializeCurrentPanel();
    setExpanded(false);
  });

  document.addEventListener('dispatch:cart-drawer:refresh', () => {
    window.setTimeout(() => {
      initializeCurrentPanel();
    }, 180);
  });

  mobileQuery.addEventListener?.('change', () => {
    if (!mobileQuery.matches) setExpanded(false);
  });

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(() => {
      initializeCurrentPanel();
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  initializeCurrentPanel();
})();
